import authenticateStepV1 from "./errorPageParams/authenticateStepV1";
import authTx from "./errorPageParams/authTx";
import enrollStepV1 from "./errorPageParams/enrollStepV1";
import { buildSpecificErrorPage } from "./GenericErrorPage";

export const EnrollStepV1ErrorPage = buildSpecificErrorPage(enrollStepV1);

export const AuthTxErrorPage = buildSpecificErrorPage(authTx);

export const AuthenticateStepV1ErrorPage =
  buildSpecificErrorPage(authenticateStepV1);
